<template>
  <v-container fluid>
    <v-expansion-panels popout accordion tile v-model="openPanel" active-class="whiteStroke" class="secondaryStroke pt-4" v-if="filteredSuppliers.length > 0" id="supplier-expansion-panels">
      <v-expansion-panel v-for="supplier in filteredSuppliers" :key="supplier.name">
        <v-expansion-panel-header :style="$vuetify.breakpoint.xs ? '' : 'height: 64px'" id="supplier-expansion-panel-header">
          <v-container fluid class="pl-0">
            <v-row align="center" no-gutters>
              <v-col cols="12" sm="" class="pr-2">
                <v-row align="center" dense>
                  <v-col cols="auto" v-if="supplier.name !== $t('noAssignedSupplier')">
                    <Icon
                      icon="mdi-account"
                      :iconColor="helpers.getTranslucent(60)"
                      :tooltipText="$t('supplier')"
                      tooltipColor="black"
                      :small="false"
                    />
                  </v-col>
                  <v-col>
                    {{ supplier.name }}
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="auto" :style="!$vuetify.breakpoint.xs ? { width: '180px' } : {}" class="body-2 py-1">
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-row no-gutters>
                      <v-col>
                        <span >{{ $t('remainingTons') }}</span>
                      </v-col>
                      <v-col cols="auto" class="pl-2">
                        {{ generateRemainingTonsString(supplier.tracts) }}
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <DataTable
            :items="supplier.tracts"
            :customCells="customCells"
            :headers="headers"
            :loading="tractsLoading"
            :showSearch="false"
            resize
          >
            <template #actions="{item}">
              <Icon
                icon="mdi-information-outline"
                :small="false"
                :tooltipText="$t('viewDetailedBreakdown')"
                @icon-clicked="openDetailDialog(item)"
              />
            </template>
            <template #status="{item}">
              <TractStatusIcon :status="item.status"/>
              <Icon
                v-if="dateIsUnderCountUnitsAway(item.harvestEndDate, 1, 'week')"
                icon="mdi-alert-outline"
                iconColor="warning"
                :tooltipText="$t('tractHarvestWarning1w')"
              />
              <Icon
                v-if="item.paused"
                icon="mdi-pause-circle"
                iconColor="warning"
                :tooltipText="$t('tractPaused')"
              />
            </template>
            <template #team="{item}">
              <v-row no-gutters>
                <v-col cols="auto">
                  <span>{{ item.teamName ?? $t('notAvailable') }}</span>
                </v-col>
                <v-col cols="auto">
                  <Icon
                  v-if="!!item.teamName"
                  iconColor="black"
                  icon="mdi-dots-horizontal"
                  margin="ml-1"
                  :tooltipText="getTeamTooltip(item.tractUserNames)"
                  />
                </v-col>
              </v-row>
            </template>
          </DataTable>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <NoData class="mt-4" v-else>
      {{ $t('noDataToDisplay') }}
    </NoData>
  </v-container>
</template>

<script>
import { helpers } from '@/plugins/theme'
import { dateIsUnderCountUnitsAway } from '@/utils/DateFormatter'
import { numberWithCommas } from '@/utils/NumericMutations.js'
export default {
  name: 'SupplierCommittedTimberPanels',

  components: {
    Icon: () => import('@/components/helper/Icon.vue'),
    DataTable: () => import('@/components/core/table/DataTable.vue'),
    TractStatusIcon: () => import('@/components/tract/TractStatusIcon.vue'),
    NoData: () => import('@/components/core/NoData.vue')
  },

  props: {
    committedTimberBySupplier: {
      type: Array,
      required: true
    },
    customCells: {
      type: Array,
      required: true
    },
    headers: {
      type: Array,
      required: true
    },
    tractsLoading: {
      type: Boolean,
      required: true
    },
    search: {
      type: String,
      default: ''
    }
  },

  data: () => ({
    helpers,
    openPanel: undefined
  }),

  computed: {
    filteredSuppliers () {
      if (this.search) {
        return this.committedTimberBySupplier.filter(ct => ct.name.toLowerCase().includes(this.search.toLowerCase()))
      } else {
        return this.committedTimberBySupplier
      }
    }
  },

  methods: {
    dateIsUnderCountUnitsAway,
    numberWithCommas,
    removeFilterField (key) {
      this.$emit('remove-filter', key)
    },
    getTeamTooltip (tractUsers) {
      return tractUsers
        .toString()
        .replaceAll(',', '\n')
    },
    openDetailDialog (item) {
      this.$emit('open-detail', item)
    },
    generateRemainingTonsString (tracts) {
      return numberWithCommas(this.generateRemainingTons(tracts), 3)
    },
    generateRemainingTons (tracts) {
      return tracts.reduce((total, t) => total + (t.remainingTons || 0), 0)
    }
  }
}
</script>
